// Modules
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// CSS
import '_Asset/css/Admin/Page/admin.css'

// Component
import { Pagination } from 'User/Component';
import {
  Paging, // Paging
  CurPageList, // 전체 리스트 정렬 및 현재 페이지 리스트 출력
  SetSortIco, // 정렬 아이콘 변경
  HandleSingleCheck, HandleAllCheck, // 체크박스 단일, 전체 선택
} from 'Admin/Component/AdFunc';

// API
import { AdKmCatApi, AdKmCatUseApi } from '_Route/Api';
import moment from 'moment';


const AdKMSpace = () => {

  // Using Hooks
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [spaceData, setSpaceData] = useState({
    pageList: [], // Req Page Data
    resList: [], // Req List Data
  })
  const { pageList, resList } = spaceData;

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);
  
  // Paging var
  const [curPage, setCurPage] = useState(1) // 현제 페이지
  const blockSize = 10 // Pagination 블럭 갯수
  const [pageSize, setPageSize] = useState(10) // 한 페이지에 노출할 게시물 갯수
  const [count, setCount] = useState('');

  // 필터 옵션
  const [filterOpt, setFilterOpt] = useState({
    search_key: '',
    search_val: params.key || '',
    kmgrp_create_date: '',
    kmgrp_last_modify_date: '',
  })
  const { search_key, search_val, kmgrp_create_date, kmgrp_last_modify_date } = filterOpt;

  // Column name / Sort var
  const columnList = [
    {name: 'No', key: 'kmgrp_no'},
    {name: '카테고리 명', key: 'km_grp'},
    {name: '작성자', key: 'kmgrp_create_user'},
    {name: '작성 일시', key: 'kmgrp_create_date'},
    {name: '마지막 수정자', key: 'kmgrp_last_modify_user'},
    {name: '마지막 수정 일시', key: 'kmgrp_last_modify_date'},
    {name: '수정', key: 'kmgrp_use'},
  ]; 
  const [sortIdx, setSortIdx] = useState(0);
  const [sortType, setSortType] = useState('');
  const [sortState, setSortState] = useState('expand'); // expand, up(DECS), down(ASC);

  // CheckBox var
  const [checkItems, setCheckItems] = useState([]);


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onFilter = (e) => {
    const { name, value } = e.target;
    setFilterOpt({...filterOpt, [name]: value});
  }

  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/admin/km/space-list${search_val === '' ? '' : '/' + encodeURIComponent(search_val)}`);
  }


  /* ========================================================================
  * Axios Space
  ========================================================================*/
  const [update, setUpdate] = useState(false); // 리스트 상태 업데이트 변수 

  // GET Space List
  useEffect(() => {
    axios.get(AdKmCatApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: filterOpt,
    })
    .then(res => {
      // console.log("GET KM Category List Success!", res);
      const sortData = res.data.result;
      
      spaceData.pageList = res.data.pageInfo
      spaceData.resList = CurPageList(sortData, sortType, sortState, curPage, pageSize)
      setSpaceData({...spaceData})
      setCount(res.data.result.length);
    })
    .catch(err => {
      console.error("GET KM Category List ERROR...", err);
    })
  }, [location, pageSize, curPage, sortState, sortIdx, update, search_key, kmgrp_create_date, kmgrp_last_modify_date])

  // PUT Space
  const UpdateUse = (spaceUuid) => {
    axios({
      url: AdKmCatUseApi,
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        kmgrp_uuid: spaceUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`KM Category 노출 여부 변경${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      setUpdate(!update)
    })
    .catch(err => {
      console.error("PUT KM Category Use ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  // DELETE Space
  const DeleteSvc = (spaceUuid, index) => {
    axios({
      url: AdKmCatApi,
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        kmgrp_uuid: spaceUuid,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      // console.log("Serivce List DELETE Success!", res);
      if(index === checkItems.length - 1) {
        alert(`${checkItems.length}개의 카테고리 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      }
      setUpdate(!update)
    })
    .catch(err => {
      console.error("Serivce List DELETE ERROR...", err);
      const errMsg = err.response.data.message
      if (errMsg && index === 0) { alert(errMsg); }
    })
  }
  
  // 일괄 삭제 함수
  const deleteFunc = () => {
    if(checkItems.length === 0) {
      alert('삭제할 카테고리를 선택해주세요.')
    } else {
      if(window.confirm(`${checkItems.length}개의 카테고리를 선택하셨습니다. \n정말 삭제${master === 1 ? '' : '를 요청'}하시겠습니까?`)) {
        checkItems.map((id, i) => { DeleteSvc(id, i) })
        setCheckItems([])
      }
    }
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>KM 카테고리 관리</h2>
        <p>Home / KM / KM 카테고리 관리</p>
      </div>

      <div className="adContArea list">

        <div className="flexBox between">
          <div className="adListBox">
            {
              userScore >= 300 &&
              <button type="button" className="btn xs red round_10" onClick={deleteFunc}>선택 삭제</button>
            }
            
            <div className="fieldGroup row gap">
              <label>노출 카테고리 수</label>

              <div className="field">
                <select name="" className="select sm type_1 round_10" onChange={(e) => setPageSize(e.target.value)} defaultValue="10">
                  <option value="10">10개 씩</option>
                  <option value="30">30개 씩</option>
                  <option value="50">50개 씩</option>
                  <option value="100">100개 씩</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>작성 일시</label>

              <div className="field">
                <select className="select sm type_1 round_10" name="kmgrp_create_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>

            <div className="fieldGroup">
              <label>마지막 수정 일시</label>

              <div className="field full">
                <select className="select sm type_1 round_10" name="kmgrp_last_modify_date" onChange={(e) => onFilter(e)}>
                  <option value="">전체</option>
                  <option value="to">오늘</option>
                  <option value="day">어제</option>
                  <option value="week">최근 1주일</option>
                  <option value="month">최근 1개월</option>
                  <option value="year">최근 1년</option>
                </select>
              </div>
            </div>
          </div>

          <div className="adListBox">
            <div className="fieldGroup row gap">
              <label>서비스 검색</label>

              <div className="field gap">
                <select className="select sm type_1 round_10" name="search_key" onChange={(e) => onFilter(e)} >
                  <option value="">통합검색</option>
                  <option value="km_grp">카테고리 명</option>
                  <option value="kmgrp_create_user">작성자</option>
                  <option value="kmgrp_last_modify_user">마지막 수정자</option>
                </select>
                <div className="inputIco">
                  <input type="text" className="input sm type_1 i_rt round_10" name="search_val" value={search_val} onChange={(e) => onFilter(e)} onKeyPress={onKeyPress} placeholder="검색어를 입력해주세요." />
                  <button type="button" className="icofont-search" onClick={onSearch}></button>
                </div>
              </div>
            </div>
            {
              userScore >= 200 &&
              <button type="button" className="btn xs sfrtBlue round_10" onClick={() => navigate('/admin/km/space-view/add')}>카테고리 등록</button>
            }
          </div>
        </div>

        <div className="table list_2">
          <table>
            <thead>
              <tr>
                <th className="check">
                  <div className="checkGroup">
                    <input type="checkbox" className='check sm blue' id="allCheck" onChange={(e) => setCheckItems(HandleAllCheck(e.target.checked, resList, 'kmgrp_uuid'))} checked={checkItems.length === resList.length ? true : false}/>
                    <label htmlFor="allCheck"></label>
                  </div>
                </th>
                {columnList.map((list, i) =>
                  <th key={i} onClick={() => {setSortState(SetSortIco(i, sortIdx, sortState)); setSortIdx(i); setSortType(list.key)}}>{list.name}<i className={`icofont-rounded-${i === sortIdx ? sortState : 'expand'}`}></i></th>
                )}
              </tr>
            </thead>
            <tbody>
              {resList.length !== 0 ?
                resList.map((data, i) => 
                  <tr key={i}>
                    <td>
                      <div className="checkGroup">
                        <input type="checkbox" className='check sm blue' id={`check_${i}`} onChange={(e) => setCheckItems(HandleSingleCheck(e.target.checked, data.kmgrp_uuid, checkItems))} checked={checkItems.includes(data.kmgrp_uuid) ? true : false}/>
                        <label htmlFor={`check_${i}`}></label>
                      </div>
                    </td>
                    <td>{data.kmgrp_no}</td>
                    <td>{data.km_grp}</td>
                    <td>{data.kmgrp_create_user}</td>
                    <td>{moment(data.kmgrp_create_date).format('YYYY-MM-DD HH:mm')}</td>
                    <td>{data.kmgrp_last_modify_user}</td>
                    <td>{moment(data.kmgrp_last_modify_date).format('YYYY-MM-DD HH:mm')}</td>
                    <td style={{width: '125px'}}>
                      <div className="btnArea col full">
                        <button type="button" className={`btn xxs ${data?.kmgrp_use === 1 ? 'sfrtBlue' : 'blue_edge'} round_10`} onClick={() => UpdateUse(data.kmgrp_uuid)}>{data?.kmgrp_use === 1 ? '사용' : '미사용'}</button>
                        <button type="button" className="btn xxs green round_10" onClick={() => navigate(`/admin/km/space-view/${data.kmgrp_uuid}`)}>카테고리 수정</button>
                      </div>
                    </td>
                  </tr>
                )
                :
                <tr>
                  <td colSpan={columnList.length + 1}>
                    <div className="noData">
                      <i className="icofont-warning-alt"></i>
                      <p>데이터가 존재하지 않습니다.</p>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div className="flexBox between paginationBox">
          <p>Showing {curPage} to {pageSize} of {pageList?.count} entries</p>

          <Pagination
            type="type_1"
            size="sm"
            curPage={curPage}
            setCurPage={setCurPage}
            pageSize={pageSize}
            blockSize={blockSize}
            startBlock={Paging(curPage, blockSize, pageSize, count).startBlock}
            endBlock={Paging(curPage, blockSize, pageSize, count).endBlock}
            pageCount={Paging(curPage, blockSize, pageSize, count).pageCount}
          />
        </div>
      </div>
    </>
  )
}

export default AdKMSpace;